var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledReceivedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E77B7B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36910_276309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1596 8.88867H6.8404C6.65251 8.88867 6.5 9.04554 6.5 9.2388V11.1546C6.5 11.3479 6.65251 11.5047 6.8404 11.5047H7.40508V18.76C7.40508 18.9536 7.55759 19.1101 7.74548 19.1101H20.2546C20.4428 19.1101 20.595 18.9537 20.595 18.76V11.5047H21.1596C21.3479 11.5047 21.5 11.3478 21.5 11.1546V9.23876C21.5 9.04554 21.3479 8.88867 21.1596 8.88867ZM19.9142 18.4099H8.08584V11.5047H19.9142V18.4099ZM20.8192 10.8045H20.2546H7.74544H7.18076V9.58888H20.8192V10.8045Z",
    fill: "#E77B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0906 17.31L13.9532 15.3938L15.8158 17.31L16.2971 16.8149L14.4345 14.8988L16.2971 12.9833L15.8158 12.4883L13.9532 14.4037L12.0906 12.4883L11.6094 12.9833L13.4719 14.8988L11.6094 16.8149L12.0906 17.31Z",
    fill: "#E77B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36910_276309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12,
    fill: "white",
    transform: "translate(6.5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledReceivedIcon);
export default __webpack_public_path__ + "static/media/CancelledReceivedIcon.5f01dcd1667eb09ae1b3b095e9ee4aef.svg";
export { ForwardRef as ReactComponent };